import { CheckCircle2 } from "lucide-react";

export default function FeedbackPanel({ finalFeedback }) {
  return (
    <article className="completion-panel" data-testid="lesson-completion-panel">
      <CheckCircle2 size={28} strokeWidth={2.6} />
      <div>
        <h3 className="font-display text-2xl font-black" data-testid="lesson-completion-title">Aula concluída</h3>
        <p className="text-sm font-semibold text-slate-600" data-testid="lesson-completion-copy">Você completou uma simulação de 15 minutos. Revise o histórico para acompanhar a pontuação.</p>
        {finalFeedback && (
          <div className="final-feedback" data-testid="lesson-final-feedback">
            <p data-testid="lesson-final-feedback-summary">{finalFeedback.summary_pt}</p>
            <div className="final-feedback-grid">
              <div data-testid="lesson-final-strengths">
                <strong>Pontos fortes</strong>
                <ul>{finalFeedback.strengths?.map((item) => <li key={item}>{item}</li>)}</ul>
              </div>
              <div data-testid="lesson-final-improvements">
                <strong>Próximos ajustes</strong>
                <ul>{finalFeedback.improvements?.map((item) => <li key={item}>{item}</li>)}</ul>
              </div>
            </div>
            <div className="practice-phrases" data-testid="lesson-final-practice-phrases">
              {finalFeedback.phrases_to_practice?.map((phrase) => <span key={phrase}>{phrase}</span>)}
            </div>
          </div>
        )}
      </div>
    </article>
  );
}